export const tradeAddress = "0x741939eEE2f933E0cCFF8E49d171101FF7080D37";
export const usdtAddress = "0x55d398326f99059ff775485246999027b3197955";
export const vaultAddress = "0x71D39F764958772428e9e0941D7A8FdC226A8491";

export const rpcUrl = import.meta.env.VITE_RPC as string;

const enrichAbiPromise = import("./Enrich.json");
const usdtAbiPromise = import("./USDT.json");
const vaultAbiPromise = import("./Vault.json");


export const contractData = async () => {
    const Enrich = await enrichAbiPromise;
    const usdtAbi = await usdtAbiPromise;
    const vaultAbi = await vaultAbiPromise;

    return {
        enrichAbi: Enrich.default,
        usdtAbi: usdtAbi.default,
        vaultAbi: vaultAbi.default,
    };
};

export const usdtApproveAbi = [
    {
        name: "approve",
        type: "function",
        stateMutability: "nonpayable",
        inputs: [
            { name: "spender", type: "address" },
            { name: "amount", type: "uint256" }
        ],
        outputs: []
    }
];
